import React from 'react';
import { SplitButton } from 'primereact/splitbutton';

/**
 * ActionsBar - Pure UI component voor save/reset acties
 * Alle logica blijft in de parent component voor veiligheid
 */
const ActionsBar = ({
	// Display state
	showSaveButton,
	
	// Event handlers (blijven in parent)
	onSave,
	onReset,
	disabled = false,
	disabledTooltip = 'Complete required fields before saving',
}) => {
	// Reset items voor SplitButton
	const resetItems = [
		{
			label: 'Reset',
			icon: 'pi pi-refresh',
			command: onReset
		}
	];

	// Render niets als save button niet moet worden getoond
	if (!showSaveButton) {
		return null;
	}

	return (
		<div className="actions-bar">
			<div className="save-section">
				<div className="save-info">
					<i className="pi pi-info-circle save-info-icon"></i>
					<span className="save-info-text">You have unsaved changes</span>
				</div>
				<SplitButton 
					label="Save" 
					icon="pi pi-check" 
					onClick={onSave} 
					model={resetItems}
					severity="success"
					disabled={disabled}
					tooltip={disabled ? disabledTooltip : ''}
				/>
			</div>
		</div>
	);
};

export default ActionsBar;
